var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsNumber } from 'class-validator';
export class CreateVehicleModelFeeDto {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVehicleModelFeeDto.prototype, "referenceHour6", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVehicleModelFeeDto.prototype, "referenceHour12", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVehicleModelFeeDto.prototype, "referenceHour24", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVehicleModelFeeDto.prototype, "referenceExcess", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVehicleModelFeeDto.prototype, "regularHour6", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVehicleModelFeeDto.prototype, "regularHour12", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVehicleModelFeeDto.prototype, "regularHour24", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVehicleModelFeeDto.prototype, "regularExcess", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVehicleModelFeeDto.prototype, "weekendHour6", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVehicleModelFeeDto.prototype, "weekendHour12", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVehicleModelFeeDto.prototype, "weekendHour24", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVehicleModelFeeDto.prototype, "weekendExcess", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVehicleModelFeeDto.prototype, "weekdayHour6", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVehicleModelFeeDto.prototype, "weekdayHour12", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVehicleModelFeeDto.prototype, "weekdayHour24", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVehicleModelFeeDto.prototype, "weekdayExcess", void 0);
